import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { OrderBaseFragmentDoc } from '../../fragments/__generated__/Order.generated';
import { GiftCardCodeFragmentDoc } from '../../fragments/__generated__/GiftCardCode.generated';
import { PromoCodeTransactionFragmentDoc } from '../../fragments/__generated__/PromoCodeTransaction.generated';
import { AddressFragmentDoc } from '../../fragments/__generated__/Address.generated';
import { OrderNoteFragmentDoc } from '../../fragments/__generated__/OrderNote.generated';
import { PaymentFragmentDoc } from '../../fragments/__generated__/Payment.generated';
import { TransactionFragmentDoc } from '../../fragments/__generated__/Transaction.generated';
import { DeliveryGroupFragmentDoc } from '../../fragments/__generated__/DeliveryGroup.generated';
import { CartBaseFragmentDoc, CartTotalPriceFragmentDoc } from '../../fragments/__generated__/Cart.generated';
import { InvoiceCompanyFileFragmentDoc } from '../../fragments/__generated__/InvoiceCompanyFile.generated';
import { CustomerDiscountFragmentDoc } from '../../fragments/__generated__/CustomerDiscount.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrderDetailsQueryVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type OrderDetailsQuery = { order: { id: string, pk: number, pubId: string, token: string, created: any, userEmail: string, status: Types.DeliveryGroupStatusEnum, isFullyPaid: boolean, isNotPaid: boolean, isShippingRequired: boolean, isDelivered: boolean, shippingMethodName: string | null, groupLastUpdated: any | null, userId: number | null, giftCardData: any, isGiftCard: boolean, shippingCustomDiscount: any, currency: string, checkoutRate: any, balanceTransactions: Array<{ id: string, amount: any, orderLineData: any, transactionType: Types.TransactionTypeEnum }>, giftCardTransactions: Array<{ id: string, pk: number, amount: any, date: any, email: string, isActive: boolean, transactionStatus: string, transactionType: Types.TransactionTypeEnum, voucherCode: string, balanceData: any, availableBalance: number, expires: any }>, promoCodeTransactions: Array<{ id: string, email: string, amount: any, transactionStatus: string, token: string, date: any, balanceData: any }>, subtotal: { currency: string, gross: number }, shippingPrice: { currency: string, gross: number }, originalShippingPrice: { currency: string, gross: number }, shippingDiscountAmount: { currency: string, gross: number }, shippingAddress: { id: string, pk: number, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, country: string, city: string, countryArea: string, phone: string, postalCode: string, defaultAddress: boolean, defaultBillingAddress: boolean, defaultShippingAddress: boolean } | null, notes: Array<{ id: string, pk: number, content: string, isPublic: boolean, date: any, creator: string, replyToMe: boolean }>, history: Array<{ id: string, pk: number, date: any, content: string }>, payments: Array<{ id: string, pk: number, created: any, currency: string, capturedAmount: number, token: string, total: number, paymentVariant: Types.PaymentVariantEnum | null, transactions: Array<{ id: string, pk: number, date: any, amount: number, feeAmt: number, transactionId: string | null, type: Types.TransactionTypeEnum }> }>, groups: Array<{ id: string, pk: number, status: Types.DeliveryGroupStatusEnum, detailStatus: Types.DeliveryGroupDetailStatusEnum, trackingNumber: string, tracking: Array<{ pk: number, id: string, status: string | null, date: any | null, country: string | null, name: string | null }>, shippingMethod: { id: string, name: string, trackingType: string | null } | null, lines: Array<{ id: string, pk: number, productName: string, isShippingRequired: boolean, quantity: number, hasFeedback: boolean, isCredit: boolean, isSubscription: boolean, unitPriceNet: any, originalPriceNet: any, discountName: string, unitCustomDiscount: any, discountAmount: { gross: number, currency: string }, supplyTotal: { gross: number, currency: string }, total: { gross: number, currency: string }, downloads: Array<{ id: string, pk: number, numAttempts: number, maxDownloads: number, fileName: string, downloadable: boolean, downloadLink: string, isOneTime: boolean, lastDownload: any | null, size: number }>, variant: { id: string, pk: number, name: string, sku: string, weightOverride: number | null, unitCoeff: number | null, thumbnail: { lg: string | null, sm: string | null }, properties: Array<{ pk: number, attributeName: string, valueName: string }>, priceRange: { currency: string, discount: { min: number, max: number } }, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, specifics: Array<{ id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string, thumbnail: { lg: string | null, sm: string | null } }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } } | null, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, thumbnail: { lg: string | null, sm: string | null } } | null, salesChannelProduct: { thumbnailUrl: string | null, id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string } | null, supplyParts: Array<{ id: string, pk: number, quantity: number, unitPriceNet: any, originalPriceNet: any, unitCustomDiscount: any, discountName: string, discountAmount: { gross: number, currency: string }, variant: { id: string, pk: number, name: string, sku: string, weightOverride: number | null, unitCoeff: number | null, properties: Array<{ pk: number, attributeName: string, valueName: string }>, priceRange: { currency: string, discount: { min: number, max: number } }, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, specifics: Array<{ id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string, thumbnail: { lg: string | null, sm: string | null } }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } } | null }> }> }>, carts: Array<{ id: string, token: any, count: number, quantity: number, type: Types.CartTypeEnum, orderId: number | null }>, invoiceFiles: Array<{ id: string, pk: number, fileUrl: string, type: string }>, customerDiscount: { id: string, pk: number, value: any } | null, totalTax: { currency: string, gross: number } | null } | null };

export type OrderBaseInfoQueryVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type OrderBaseInfoQuery = { order: { id: string, pk: number, token: string, userEmail: string, userId: number | null } | null };

export type OrderSuccessPageInfoQueryVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type OrderSuccessPageInfoQuery = { order: { id: string, pk: number, pubId: string, token: string, created: any, userEmail: string, status: Types.DeliveryGroupStatusEnum, isFullyPaid: boolean, isNotPaid: boolean, isShippingRequired: boolean, isDelivered: boolean, shippingMethodName: string | null, groupLastUpdated: any | null, userId: number | null, giftCardData: any, isGiftCard: boolean, shippingCustomDiscount: any, currency: string, checkoutRate: any, balanceTransactions: Array<{ id: string, amount: any, orderLineData: any, transactionType: Types.TransactionTypeEnum }>, giftCardTransactions: Array<{ id: string, pk: number, amount: any, date: any, email: string, isActive: boolean, transactionStatus: string, transactionType: Types.TransactionTypeEnum, voucherCode: string, balanceData: any, availableBalance: number, expires: any }>, promoCodeTransactions: Array<{ id: string, email: string, amount: any, transactionStatus: string, token: string, date: any, balanceData: any }>, subtotal: { currency: string, gross: number }, shippingPrice: { currency: string, gross: number }, originalShippingPrice: { currency: string, gross: number }, shippingAddress: { id: string, pk: number, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, country: string, city: string, countryArea: string, phone: string, postalCode: string, defaultAddress: boolean, defaultBillingAddress: boolean, defaultShippingAddress: boolean } | null, payments: Array<{ id: string, pk: number, created: any, currency: string, capturedAmount: number, token: string, total: number, paymentVariant: Types.PaymentVariantEnum | null, transactions: Array<{ id: string, pk: number, date: any, amount: number, feeAmt: number, transactionId: string | null, type: Types.TransactionTypeEnum }> }>, groups: Array<{ id: string, pk: number, status: Types.DeliveryGroupStatusEnum, detailStatus: Types.DeliveryGroupDetailStatusEnum, trackingNumber: string, tracking: Array<{ pk: number, id: string, status: string | null, date: any | null, country: string | null, name: string | null }>, shippingMethod: { id: string, name: string, trackingType: string | null } | null, lines: Array<{ id: string, pk: number, productName: string, isShippingRequired: boolean, quantity: number, hasFeedback: boolean, isCredit: boolean, isSubscription: boolean, unitPriceNet: any, originalPriceNet: any, discountName: string, unitCustomDiscount: any, discountAmount: { gross: number, currency: string }, supplyTotal: { gross: number, currency: string }, total: { gross: number, currency: string }, downloads: Array<{ id: string, pk: number, numAttempts: number, maxDownloads: number, fileName: string, downloadable: boolean, downloadLink: string, isOneTime: boolean, lastDownload: any | null, size: number }>, variant: { id: string, pk: number, name: string, sku: string, weightOverride: number | null, unitCoeff: number | null, thumbnail: { lg: string | null, sm: string | null }, properties: Array<{ pk: number, attributeName: string, valueName: string }>, priceRange: { currency: string, discount: { min: number, max: number } }, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, specifics: Array<{ id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string, thumbnail: { lg: string | null, sm: string | null } }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } } | null, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, thumbnail: { lg: string | null, sm: string | null } } | null, salesChannelProduct: { thumbnailUrl: string | null, id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string } | null, supplyParts: Array<{ id: string, pk: number, quantity: number, unitPriceNet: any, originalPriceNet: any, unitCustomDiscount: any, discountName: string, discountAmount: { gross: number, currency: string }, variant: { id: string, pk: number, name: string, sku: string, weightOverride: number | null, unitCoeff: number | null, properties: Array<{ pk: number, attributeName: string, valueName: string }>, priceRange: { currency: string, discount: { min: number, max: number } }, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, specifics: Array<{ id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string, thumbnail: { lg: string | null, sm: string | null } }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } } | null }> }> }>, totalTax: { currency: string, gross: number } | null, shippingDiscountAmount: { currency: string, gross: number } } | null };

export type TrackOrderQueryVariables = Types.Exact<{
  pubId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  email?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type TrackOrderQuery = { order: { id: string, token: string } | null };

export type OrderNotesQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  orderToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type OrderNotesQuery = { orderNotes: { edges: Array<{ node: { id: string, pk: number, content: string, isPublic: boolean, date: any, creator: string, replyToMe: boolean } }> } };


export const OrderDetailsDocument = gql`
    query OrderDetails($token: String!) {
  order(token: $token) {
    ...OrderBaseFragment
    balanceTransactions {
      id
      amount
      orderLineData
      transactionType
    }
    giftCardTransactions {
      ...GiftCardCodeFragment
    }
    promoCodeTransactions {
      ...PromoCodeTransactionFragment
    }
    subtotal {
      currency
      gross
    }
    shippingPrice {
      currency
      gross
    }
    originalShippingPrice {
      currency
      gross
    }
    shippingDiscountAmount {
      currency
      gross
    }
    shippingAddress {
      ...AddressFragment
    }
    notes {
      ...OrderNoteFragment
    }
    history(ordering: {date: DESC}) {
      id
      pk
      date
      content
    }
    payments {
      ...PaymentFragment
      transactions {
        ...TransactionFragment
      }
    }
    groups {
      ...DeliveryGroupFragment
    }
    carts {
      ...CartBaseFragment
    }
    invoiceFiles {
      ...InvoiceCompanyFileFragment
    }
    customerDiscount {
      ...CustomerDiscountFragment
    }
  }
}
    ${OrderBaseFragmentDoc}
${GiftCardCodeFragmentDoc}
${PromoCodeTransactionFragmentDoc}
${AddressFragmentDoc}
${OrderNoteFragmentDoc}
${PaymentFragmentDoc}
${TransactionFragmentDoc}
${DeliveryGroupFragmentDoc}
${CartBaseFragmentDoc}
${InvoiceCompanyFileFragmentDoc}
${CustomerDiscountFragmentDoc}`;

/**
 * __useOrderDetailsQuery__
 *
 * To run a query within a React component, call `useOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDetailsQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<OrderDetailsQuery, OrderDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderDetailsQuery, OrderDetailsQueryVariables>(OrderDetailsDocument, options);
      }
export function useOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderDetailsQuery, OrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderDetailsQuery, OrderDetailsQueryVariables>(OrderDetailsDocument, options);
        }
export type OrderDetailsQueryHookResult = ReturnType<typeof useOrderDetailsQuery>;
export type OrderDetailsLazyQueryHookResult = ReturnType<typeof useOrderDetailsLazyQuery>;
export type OrderDetailsQueryResult = Apollo.QueryResult<OrderDetailsQuery, OrderDetailsQueryVariables>;
export function refetchOrderDetailsQuery(variables: OrderDetailsQueryVariables) {
      return { query: OrderDetailsDocument, variables: variables }
    }
export const OrderBaseInfoDocument = gql`
    query OrderBaseInfo($token: String!) {
  order(token: $token) {
    id
    pk
    token
    userEmail
    userId
  }
}
    `;

/**
 * __useOrderBaseInfoQuery__
 *
 * To run a query within a React component, call `useOrderBaseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderBaseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderBaseInfoQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useOrderBaseInfoQuery(baseOptions: Apollo.QueryHookOptions<OrderBaseInfoQuery, OrderBaseInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderBaseInfoQuery, OrderBaseInfoQueryVariables>(OrderBaseInfoDocument, options);
      }
export function useOrderBaseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderBaseInfoQuery, OrderBaseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderBaseInfoQuery, OrderBaseInfoQueryVariables>(OrderBaseInfoDocument, options);
        }
export type OrderBaseInfoQueryHookResult = ReturnType<typeof useOrderBaseInfoQuery>;
export type OrderBaseInfoLazyQueryHookResult = ReturnType<typeof useOrderBaseInfoLazyQuery>;
export type OrderBaseInfoQueryResult = Apollo.QueryResult<OrderBaseInfoQuery, OrderBaseInfoQueryVariables>;
export function refetchOrderBaseInfoQuery(variables: OrderBaseInfoQueryVariables) {
      return { query: OrderBaseInfoDocument, variables: variables }
    }
export const OrderSuccessPageInfoDocument = gql`
    query OrderSuccessPageInfo($token: String!) {
  order(token: $token) {
    ...OrderBaseFragment
    balanceTransactions {
      id
      amount
      orderLineData
      transactionType
    }
    giftCardTransactions {
      ...GiftCardCodeFragment
    }
    promoCodeTransactions {
      ...PromoCodeTransactionFragment
    }
    subtotal {
      currency
      gross
    }
    shippingPrice {
      currency
      gross
    }
    originalShippingPrice {
      currency
      gross
    }
    shippingAddress {
      ...AddressFragment
    }
    payments {
      ...PaymentFragment
      transactions {
        ...TransactionFragment
      }
    }
    groups {
      ...DeliveryGroupFragment
    }
  }
}
    ${OrderBaseFragmentDoc}
${GiftCardCodeFragmentDoc}
${PromoCodeTransactionFragmentDoc}
${AddressFragmentDoc}
${PaymentFragmentDoc}
${TransactionFragmentDoc}
${DeliveryGroupFragmentDoc}`;

/**
 * __useOrderSuccessPageInfoQuery__
 *
 * To run a query within a React component, call `useOrderSuccessPageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSuccessPageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSuccessPageInfoQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useOrderSuccessPageInfoQuery(baseOptions: Apollo.QueryHookOptions<OrderSuccessPageInfoQuery, OrderSuccessPageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderSuccessPageInfoQuery, OrderSuccessPageInfoQueryVariables>(OrderSuccessPageInfoDocument, options);
      }
export function useOrderSuccessPageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSuccessPageInfoQuery, OrderSuccessPageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderSuccessPageInfoQuery, OrderSuccessPageInfoQueryVariables>(OrderSuccessPageInfoDocument, options);
        }
export type OrderSuccessPageInfoQueryHookResult = ReturnType<typeof useOrderSuccessPageInfoQuery>;
export type OrderSuccessPageInfoLazyQueryHookResult = ReturnType<typeof useOrderSuccessPageInfoLazyQuery>;
export type OrderSuccessPageInfoQueryResult = Apollo.QueryResult<OrderSuccessPageInfoQuery, OrderSuccessPageInfoQueryVariables>;
export function refetchOrderSuccessPageInfoQuery(variables: OrderSuccessPageInfoQueryVariables) {
      return { query: OrderSuccessPageInfoDocument, variables: variables }
    }
export const TrackOrderDocument = gql`
    query TrackOrder($pubId: String, $email: String) {
  order(pubId: $pubId, email: $email) {
    id
    token
  }
}
    `;

/**
 * __useTrackOrderQuery__
 *
 * To run a query within a React component, call `useTrackOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackOrderQuery({
 *   variables: {
 *      pubId: // value for 'pubId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useTrackOrderQuery(baseOptions?: Apollo.QueryHookOptions<TrackOrderQuery, TrackOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackOrderQuery, TrackOrderQueryVariables>(TrackOrderDocument, options);
      }
export function useTrackOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackOrderQuery, TrackOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackOrderQuery, TrackOrderQueryVariables>(TrackOrderDocument, options);
        }
export type TrackOrderQueryHookResult = ReturnType<typeof useTrackOrderQuery>;
export type TrackOrderLazyQueryHookResult = ReturnType<typeof useTrackOrderLazyQuery>;
export type TrackOrderQueryResult = Apollo.QueryResult<TrackOrderQuery, TrackOrderQueryVariables>;
export function refetchTrackOrderQuery(variables?: TrackOrderQueryVariables) {
      return { query: TrackOrderDocument, variables: variables }
    }
export const OrderNotesDocument = gql`
    query OrderNotes($first: Int!, $orderToken: String, $orderId: ID) {
  orderNotes(
    first: $first
    filters: {order: {token: {exact: $orderToken}, id: {exact: $orderId}}}
  ) {
    edges {
      node {
        ...OrderNoteFragment
      }
    }
  }
}
    ${OrderNoteFragmentDoc}`;

/**
 * __useOrderNotesQuery__
 *
 * To run a query within a React component, call `useOrderNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderNotesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      orderToken: // value for 'orderToken'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderNotesQuery(baseOptions: Apollo.QueryHookOptions<OrderNotesQuery, OrderNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderNotesQuery, OrderNotesQueryVariables>(OrderNotesDocument, options);
      }
export function useOrderNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderNotesQuery, OrderNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderNotesQuery, OrderNotesQueryVariables>(OrderNotesDocument, options);
        }
export type OrderNotesQueryHookResult = ReturnType<typeof useOrderNotesQuery>;
export type OrderNotesLazyQueryHookResult = ReturnType<typeof useOrderNotesLazyQuery>;
export type OrderNotesQueryResult = Apollo.QueryResult<OrderNotesQuery, OrderNotesQueryVariables>;
export function refetchOrderNotesQuery(variables: OrderNotesQueryVariables) {
      return { query: OrderNotesDocument, variables: variables }
    }